import {atom} from "recoil";
import {User} from "../../models/User";
import {Scope} from "../../models/KakaoScopes";

export const authLoadingState = atom<boolean>({
    key: 'authLoadingState',
    default: false,
})

export const userState = atom<User | null> ({
    key: 'userState',
    default: null,
});

export const isHandlingOauthCallbackState = atom<boolean> ({
    key: 'isHandlingOauthCallbackState',
    default: false,
})

export const userKakaoScopeState = atom<Scope[]> ({
    key: 'userKakaoScopeState',
    default: [],
})